export const readRate = (text: string, wpm = 225): number => {
  const words = text.split(/\s+/).filter((w) => w != "").length;
  const rate = words / wpm;
  return rate;
};

export const readtime = (text: string, wpm?: number): number => Math.ceil(readRate(text, wpm)); // ! Result in Mintes eg. to convert, you need before multiply by 60
